import React, { useEffect, useRef, useState } from "react";
import ReactCalendar from "react-calendar";
import { DateUtility } from "../../../../utils/dateUtility";
import { getCurrentDate, getNextSevenDays, makeDateUrl, normalizeSport } from "../../../../utils/generalLiveCenter";

const FilterDate = ({
  sport = "football",
  dictionary = {},
  setDate,
  date,
  setIsLive,
  isLive,
  dataClient,
  websiteBaseUrl = false,
  dataPath,
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [value, setValue] = useState(getCurrentDate());
  const calendarRef = useRef(null);

  const todayDate = new Date().toISOString().split("T")[0];
  const nextDates = getNextSevenDays(dictionary);
  const normalizedSport = normalizeSport(sport);

  const handleChange = (selectedDate) => {
    const formatted = DateUtility?.ConvertDate(selectedDate);
    if (dataClient) {
      redirectToDate(formatted);
    } else {
      setValue(selectedDate);
      setDate(formatted);
      setShowCalendar(false);
      setIsLive(false);
    }
  };

  const handleLiveClick = () => {
    if (dataClient) {
      redirectToDate("live");
    } else {
      setIsLive(true);
      setDate(todayDate);
    }
  };

  const redirectToDate = (slug) => {
    const url = makeDateUrl({
      websiteBaseUrl,
      dataPath,
      sport: normalizedSport,
      slug,
    });
    window.location.href = url;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="days_nav_wrap" ref={calendarRef}>
      <div
        className={`live_btn_link ${isLive === "true" ? "active" : ""}`}
        onClick={handleLiveClick}
      >
        <i className="ico_live"></i>
        <span>{dictionary?.live || "Live"}</span>
      </div>

      <ul className="days_nav">
        {nextDates.map(({ slugDate, day, date: label }, index) => {
          const isActive = slugDate === date;

          const handleDateClick = () => {
            if (dataClient) {
              redirectToDate(slugDate);
            } else {
              setDate(slugDate);
              setIsLive(false);
            }
          };

          return (
            <li key={index}>
              <div
                className={isActive ? isLive === 'true' ? "today" : "active" : "test"}
                onClick={handleDateClick}
              >
                <strong className="day">{dictionary?.[day.toLowerCase()] || day}</strong>
                <span className="date">{label}</span>
              </div>
            </li>
          );
        })}
      </ul>

      <span className="calendar_opener" onClick={() => setShowCalendar(!showCalendar)}>
        <i className="ico_calendar"></i>
      </span>

      {showCalendar && (
        <ReactCalendar
          onChange={handleChange}
          className="calendar_container"
          value={value}
          prev2Label={null}
          next2Label={null}
          minDetail="month"
        />
      )}
    </div>
  );
};

export default FilterDate;